import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect, useRef } from 'react';
import TransitChargeState from '~/constants/vdp/TransitChargeState';
import { useIsLoggedIn, useUserLocation } from '~/context/common/UserContext';
import { useSoonestRoute } from '~/context/vdp/DeliveryPickupContext';
import {
  useTransitChargeInfo,
  useTransitRoute
} from '~/context/vdp/UserVehicleContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';

export default function useSendTransitCharge(): void {
  const { trackEvent } = useContext(AnalyticsContext);
  const { zip } = useUserLocation();
  const isLoggedIn = useIsLoggedIn();
  const soonestRoute = useSoonestRoute();
  const transitCharge = useTransitChargeInfo();
  const transitRoute = useTransitRoute();
  const { location: { locationId } = {} } = useGetVehicleDetails();

  const isLoggedInRef = useRef(isLoggedIn);
  useEffect(() => {
    isLoggedInRef.current = isLoggedIn;
  }, [isLoggedIn]);

  const activityTypeRef = useRef(soonestRoute?.activityType);
  useEffect(() => {
    activityTypeRef.current = soonestRoute?.activityType;
  }, [soonestRoute?.activityType]);

  const servicingLocationIdRef = useRef(soonestRoute?.servicingLocationId);
  useEffect(() => {
    servicingLocationIdRef.current = soonestRoute?.servicingLocationId;
  }, [soonestRoute?.servicingLocationId]);

  const zipRef = useRef(zip);
  useEffect(() => {
    zipRef.current = zip;
  }, [zip]);

  useEffect(() => {
    if (transitCharge.state === TransitChargeState.Unknown) return;

    trackEvent('Transit Charge', {
      isLoggedIn: isLoggedInRef.current,
      locationId,
      servicingLocationId: servicingLocationIdRef.current ?? null,
      merchSelectedActivityType: activityTypeRef.current ?? null,
      routeId: transitRoute.routeId,
      quoteSelectedActivityType: transitRoute.activityType ?? null,
      transitCharge: transitCharge.charge,
      zip: zipRef.current
    });
  }, [
    locationId,
    trackEvent,
    transitCharge.charge,
    transitCharge.state,
    transitRoute.activityType,
    transitRoute.routeId
  ]);
}
